export const decodeEntities = (e) => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = e;
  return textArea.value;
};

export const getCompanyNameByCode = (code) => {
  // Case is correct, do not modify :)
  const mapping = {
    nov: 'NOVASOL',
    dan: 'dansommer',
    cue: 'Cuendet',
  };

  return mapping.hasOwnProperty(code.toLowerCase()) ? mapping[code.toLowerCase()] : mapping.nov;
};

export const getTicketGroupName = (ticketId) => {
  const mapping = {
    1: 'LEGOLAND® Billund',
    2: 'Djurs Sommerland',
  };

  return mapping.hasOwnProperty(ticketId) ? mapping[ticketId] : '';
};

export const formatMoney = (number, numberOfSuffix, suffixDelimeter, thousandDecimeter) => {
  const s = number < 0 ? '-' : '';
  const buffNumber = Math.abs(Number(number) || 0);
  const i = String(parseInt(buffNumber.toFixed(numberOfSuffix),
    10));
  let j = i.length;
  j = j > 3 ? j % 3 : 0;
  return s
    + (j ? i.substr(0,
      j) + thousandDecimeter : '')
    + i.substr(j).replace(/(\d{3})(?=\d)/g,
      `$1${thousandDecimeter}`)
    + (numberOfSuffix ? suffixDelimeter + Math.abs(buffNumber - i).toFixed(numberOfSuffix)
      .slice(2) : '');
};


export const prepaidVoucherExist = (prepaidVoucher) =>!!prepaidVoucher && !!prepaidVoucher.amount > 0;
